import React, { PropsWithChildren } from 'react';
import { Card, CardTitle } from '@raptormaps/card';
import { Icon, IconProps } from '@raptormaps/icon';
import { CardHeader, CardIcon, CardBody } from './FarmInfoCard.styles';

interface FarmInfoCardProps extends PropsWithChildren {
  icon: IconProps['icon'];
  title: string;
  children: React.ReactNode;
  className?: string;
}

export function FarmInfoCard({
  icon,
  title,
  children,
  className,
}: FarmInfoCardProps) {
  return (
    <Card gutter="none" style={{ overflow: 'hidden' }} className={className}>
      <CardHeader>
        <CardIcon>
          <Icon icon={icon} />
        </CardIcon>
        <CardTitle>{title}</CardTitle>
      </CardHeader>
      <CardBody>{children}</CardBody>
    </Card>
  );
}
